import React, { Fragment } from 'react';
import Deslizador from './deslizador';
import ListaCarrera from './listadoCarrera';
import Hobbies from './hobbies';
import MisLogros from './logrosApp';

function App() {
  return (
    <Fragment>
      <Deslizador/>
    </Fragment>
  );
}

function AppTwo() {
  return (
    <Fragment>
      <ListaCarrera/>
    </Fragment>
  );
}

function AppThree() {
  return (
    <Fragment>
      <Hobbies/>
    </Fragment>
  );
}

function AppFour() {
  return (
    <Fragment>
      <MisLogros/>
    </Fragment>
  );
}

export { App };
export { AppTwo };
export { AppThree };
export { AppFour };